import React from "react";
import { Container } from "react-bootstrap";
import "./PrivacyPolicy.css";

function TermsCondition_User() {
  return (
    <>
      <section className="privacy_section">
        <Container>
          <div className="privacy_main">
            <div className="title_div mb-4">
              <h2 className="semi_title">TERMS & CONDITIONS</h2>
            </div>
            <div className="mb-md-3 mb-3 ">
              <p className="text ">
                <strong>
                  “Smartshift Info Marketing Services Private Limited”
                </strong>{" "}
                or,
                <strong>“SG Transport”</strong> is a company which is, inter alia,
                engaged in the business of transportation of goods by road
                through Compact Three Wheeler Vehicles (
                <strong>“Compact 3W”</strong>).
              </p>
            </div>
            <div>
              <p className="sub_title">GENERAL TERMS AND CONDITIONS</p>
              <ol>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Consignments entrusted to{" "}
                    <strong>Smartshift Info Marketing Services</strong>
                    Private Limited (<strong>“SG Transport”</strong>) by you
                    (hereinafter referred to as{" "}
                    <strong>“Consignor/Sender/Customer”</strong> (as the case
                    may be)) for transportation shall be on agreed terms and
                    conditions as specified below.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor/Sender/Customer (as the case may be)
                    acknowledge that, upon their acceptance of the terms and
                    conditions listed below, these terms and conditions shall be
                    binding on them and SG Transport. If the Consignor/ Sender/
                    Customer opts not to agree to these terms and conditions or
                    does not wish to avail the services provided by SG Transport, they
                    should uninstall the SG Transport app from their mobile phones and
                    discontinue the use of SG Transport’s services. Each time that the
                    Consignor/ Sender/ Customer sends any consignment through
                    SG Transport services, the Consignor/ Sender/ Customer
                    acknowledges the terms and conditions herein.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    These SG Transport Customer Terms and Conditions apply to the
                    services provided by SG Transport currently including the
                    following services: 3W.
                  </p>
                </li>

                <li className="text mb-md-3 mb-3">
                  <p> Goods Transport by Road through Compact 3W.</p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Other than these General Terms and Conditions, the
                    Consignor/Sender/Customer (as the case may be) shall be
                    subject to the specific terms and conditions of Goods
                    Transport through Compact 3W.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor or Sender or Customer (as the case may be)
                    warrants and undertakes that all Consignments in respect of
                    which SG Transport is to provide its services are either owned by
                    the Consignor or Sender or Customer (as the case may be) or
                    legally in their possession or under their control, and that
                    the Consignor or Sender or Customer (as the case may be) is
                    able to deal with the Consignments as contemplated herein.
                    The Consignor or Sender or Customer (as the case may be)
                    agrees to indemnify SG Transport against any loss, damage or claim
                    made against SG Transport arising from any lack of authority of
                    the Consignor or Sender or Customer (as the case may be) to
                    contract with SG Transport for the Services, or any breach of the
                    warranty or undertaking given by the Consignor or Sender or
                    Customer (as the case may be) under this paragraph.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport may vary or amend or change or update these Terms and
                    Conditions, from time to time entirely at its own
                    discretion. You shall be responsible for checking these
                    Terms and Conditions from time to time and ensure continued
                    compliance with the terms and conditions. The continued use
                    of SG Transport’s services by the Consignor or Sender or Customer
                    (as the case may be), after any such amendment or change in
                    the Terms and Conditions shall be deemed as your express
                    acceptance to such amended/changed terms and you also agree
                    to be bound by such changed/amended Terms and Conditions.
                    You agree that SG Transport's services are subject to all
                    prevailing statutory taxes, duties, fees, charges and/or
                    costs, however denominated, as may be applicable from time
                    to time. It shall be your responsibility to ensure that you
                    comply with applicable laws on payment of taxes and pay the
                    prevailing charges and duties which shall form part of the
                    invoice raised by SG Transport.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Governing Law and Dispute Resolution: These SG Transport Customer
                    Terms and Conditions shall be governed by the laws of India
                    and subject to the mediation clause specified hereunder, the
                    courts in Bangalore shall have exclusive jurisdiction to
                    deal with any matter pertaining to these Terms and
                    Conditions. Any disputes between SG Transport and Consignor or
                    Sender or Customer (as the case may be) or anybody claiming
                    through or on behalf of the Consignor/Sender/Customer (
                    <strong>“Disputing Parties”</strong>) that cannot be settled
                    amicably within a period of 30 (thirty) days from the date
                    of the dispute may be resolved by mediation in accordance
                    with the Karnataka Civil Procedure (Mediation) Rules, 2005
                    before the Karnataka Mediation Centre, Bangalore (
                    <strong>“Institution”</strong>). A neutral mediator shall be
                    appointed by the Institution to facilitate the mediation
                    process. The Disputing Parties shall keep the mediation
                    confidential and not disclose to any person, unless required
                    to do so under applicable law.
                  </p>
                </li>

                <li className="text mb-md-3 mb-3">
                  <p>We act only as a service platform; all responsibilities rest entirely with them.</p>
                </li>
              </ol>

              {/* <p className="sub_title">
                CLAIMS (As applicable to ‘Goods Transport by Road’)
              </p>
              <ol>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Any claim (for accidents or negligence resulting in damage)
                    in respect of the goods shall be made in writing within 24
                    (twenty four) hours from the date of receipt and sent to
                    <a href="mailto:sgtransportwala1@gmail.com">
                      <b> sgtransportwala1@gmail.com </b>
                    </a>{" "}
                    for Goods Transport service through Compact 3W. In case of
                    damaged goods, the Consignor/Customer (as the case may be)
                    and/or consignee needs to share photos of the damaged goods
                    in case of Goods Transport services through Compact 3W,
                    along with the description of the damage. In absence of any
                    such claims, made within the period stipulated here, SG Transport
                    shall not be liable to process the same.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    When claiming refund against damage, the Consignor/Customer
                    must verify their identity as the original
                    Consignor/Customer of the goods. SG Transport may ask for relevant
                    information to validate the identity of the claimant in this
                    case. In case the identity of the claimant cannot be
                    validated by SG Transport, the refund request will not be
                    processed.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor/Customer hereby undertake and agree that,
                    should they so desire, they shall opt for additional
                    coverage to secure the goods from point of origin to point
                    of final destination at their own cost; provided, for any
                    goods above the value of INR 1,500 (Rupees One Thousand Five
                    Hundred), the Consignor/Customer will necessarily obtain
                    insurance coverage from point of origin to point of final
                    destination at their own cost.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    No commitment is made for time bound completion of service.
                    Any time of arrival/delivery provided at booking is an
                    estimate only and, there may be occasional delays for
                    reasons outside SG Transport’s control. SG Transport shall not be liable
                    for any loss arising from such delays.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Customer shall specify the accurate details of the goods
                    at the time of booking, including nature of goods, quantity,
                    volume, specifications etc.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Reverse liability: In the event of mis-declaration of the
                    goods (including without limitation where the goods are
                    already damaged or damage other goods while under carriage
                    or are illegal goods/consignment) the Consignor/Customer
                    shall be liable for any damages related to such misdeclared
                    goods including consequential and third party damages.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Void liability: In the event of mis-declaration of the
                    goods, SG Transport shall not be liable for any claims on
                    compensation or the logistics-related costs or charges or
                    the declared value of goods nor statutory or legal
                    responsibilities of such goods.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Under no circumstances will SG Transport or any of its director,
                    officer, employee, agent or contractor be liable to the
                    Consignor/Customer or consignee for any indirect,
                    incidental, consequential, special or exemplary losses or
                    damages, mis-delivery, or non-delivery of consignment for
                    any reason whatsoever. More particularly, SG Transport shall not
                    be liable for any loss of income, profits, interests or
                    other consequential losses.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Refund Period: All eligible refunds shall be processed
                    within 7 – 10 working days from the day the claim has been
                    accepted by SG Transport upon submission of complete documents
                    pertaining to the dispute by the Consignor/Customer, except
                    where such refund cannot be processed due to reasons not
                    attributable to SG Transport.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Where the Consignor/Customer is registered under the GST
                    regulations, the same should be intimated to SG Transport through
                    the SG Transport App. Further, any change in status of GSTIN shall
                    also be intimated to SG Transport prior to initiation of the
                    service.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport is a “goods transport agency” (GTA) under the Central
                    Goods and Services Tax Act, 2017 (GST) and has opted for tax
                    on reverse charge basis for transportation service rendered
                    to GST registered customers. Accordingly, in case the
                    Consignor/Customer is registered under GST provisions (as
                    per the information provided on the SG Transport App), the
                    Consignor/Customer is liable to pay the GST under reverse
                    charge mechanism (RCM) on the invoices raised by SG Transport.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor/Customer may be contacted by SG Transport for
                    furnishing additional details required to process
                    compensation towards loss or damage of the goods. The
                    additional details requested may include, without
                    limitation, images to prove damage to the goods and/or bank
                    details of the Consignor/Customer to which the compensation
                    should be credited. SG Transport will not be liable for payment of
                    any compensation if the details requested by it are not
                    provided within 2 working days from the date on which the
                    initial e-mail request is sent to the Consignor/Customer.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Blocking of access: The Consignor/Customer acknowledges and
                    agrees that SG Transport may block their access to its services,
                    in whole or in part, at any time and for any reason, at
                    SG Transport's sole discretion, without prior notice or liability.
                    Such reasons may include, without limitation, violation of
                    these terms and conditions, applicable law, or SG Transport's
                    policies, misuse of SG Transport's services, security risks, or
                    fraudulent activities.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Pure Agent Relationship in Respect of Certain Costs Incurred
                    by SG Transport on behalf of the Customer: In the event that the
                    Customer avails the services of SG Transport Wallet to make
                    hassle-free, quick, and seamless transactions in respect of
                    SG Transport Services, the Customer authorizes SG Transport to act as
                    their pure agent for procuring the services of Payment
                    Aggregators (“PAs”) and/or Payment Gateways (“PGs”) which
                    are linked to the recharge and maintenance of SG Transport Wallet.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Cash on Delivery Payment Term: If a Consignor/Customer has
                    opted for a cash on delivery payment option, the
                    Consignor/Customer must pay the full amount to the delivery
                    partner as reflected on the SG Transport app at the time of
                    completion of the services.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Reward schemes: Users will be eligible to use the valid
                    rewards/ vouchers/ coins of SG Transport’s affiliates towards the
                    dues for this service.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Cancellation: All cancellations made after driver allocation
                    may incur a cancellation fee based on company policies. The
                    same, if any, shall be communicated at the time of
                    cancellation.
                  </p>
                </li>
              </ol> */}
            </div>
          </div>
        </Container>
        <div className="privacy_overlay"></div>
      </section>
    </>
  );
}

export default TermsCondition_User;
